module.exports = __webpack_public_path__ + "static/media/ic-close.92965c2f.svg";